import { orchestrator } from 'satcheljs';
import { logNewConsumerRecruitmentResponse } from '../actions/logNewConsumerRecruitmentResponse';
import { sendNewConsumerRecruitmentDatapoint } from '../services/sendNewConsumerRecruitmentDatapoint';

export default orchestrator(logNewConsumerRecruitmentResponse, async userResponse => {
    sendNewConsumerRecruitmentDatapoint({
        firstName: userResponse.firstName,
        userEmail: userResponse.userEmail,
        ageResponse: userResponse.ageResponse,
        purposeResponse: userResponse.purposeResponse,
    });
});
